import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-63">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-64">
        <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Misty mountain trail in the morning light" className="w-full h-full object-cover" data-id="element-65" />
        <div className="absolute inset-0 bg-forest-900/40 mix-blend-multiply" data-id="element-66" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-earth-100" data-id="element-67" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto" data-id="element-68">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="inline-block text-earth-100 text-lg md:text-xl tracking-[0.2em] uppercase font-medium mb-4" data-id="element-69">
          Budapest • Hungary
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-white mb-6 drop-shadow-lg" data-id="element-70">
          Fableworld
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-xl md:text-2xl text-earth-100 max-w-2xl mx-auto font-light leading-relaxed mb-10" data-id="element-71">
          Discover the untold stories of the wild. Join our community of
          wanderers on trails less traveled.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-72">
          <a href="#upcoming" className="inline-block bg-sunset-600 hover:bg-sunset-500 text-white px-8 py-4 rounded-full font-medium tracking-wide transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-73">
            Find Your Adventure
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/80" data-id="element-74">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-75">
          <ArrowDown className="w-8 h-8" data-id="element-76" />
        </motion.div>
      </motion.div>
    </section>;
}